module.exports = __webpack_public_path__ + "img/teaching_5_en.43c08180.png";